import storageApi from '@picsart/rc/services/storage';

import { LOCAL_STORAGE_KEYS, LOCAL_STORAGE_PREFIX, REMOTE_THEMES } from 'configs/constants';

import type { IGeneralState } from 'types';

const initialState: IGeneralState = {
  user: {
    isAuthorized: false,
    isSubscribed: false,
    isTrialUsed: false,
    waitingUserSubscription: true,
    subscriptionType: null,
    tiers: [],
  },
  isDarkModeEnabled: storageApi.getSync(LOCAL_STORAGE_PREFIX, LOCAL_STORAGE_KEYS.theme) === REMOTE_THEMES.Dark,
  useOsTheme: storageApi.getSync(LOCAL_STORAGE_PREFIX, LOCAL_STORAGE_KEYS.theme) === REMOTE_THEMES.System,
};

export default initialState;
